import { createEmptySliceBase, injectDetailSlice, toReducer } from '../sliceFactory';

const createVehiclesReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'vehicles' });
  const withDetail = injectDetailSlice({ sliceBase });
  return toReducer(withDetail);
};

export default createVehiclesReducer;
